// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#one-table{height:100%;width:100%;justify-content:center;align-items:center}.pagination_init{margin-top:10px}.table_operation_or_search{margin-bottom:10px}.table_operation_or_search-right{float:left;margin-bottom:10px}.table_operation_or_search-left{float:right}.table-col-options-button{display:inline-block;margin-left:10px}.table-image-column{width:100px;height:100px}", ""]);
// Exports
module.exports = exports;
